import {
  TranscriptionRequest,
  TranscriptionResponse,
} from "@cohesive/api-client";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { orgAPI } from "./api";

export interface AudioTranscriptionArgs {
  audioBlob: Blob;
  options?: Omit<TranscriptionRequest, "file">;
}

export function useAudioTranscription(
  mutationOptions?: UseMutationOptions<
    TranscriptionResponse,
    AxiosError,
    AudioTranscriptionArgs
  >,
) {
  return useMutation<TranscriptionResponse, AxiosError, AudioTranscriptionArgs>(
    {
      mutationFn: async ({ audioBlob, options }) => {
        return await orgAPI.audioTranscription.transcribeAudio(
          audioBlob,
          options,
        );
      },
      ...mutationOptions,
    },
  );
}
